module.exports = __webpack_public_path__ + "img/45.c3241110.png";